import { Directive, Input } from '@angular/core';
import { Validator, FormGroup, ValidationErrors, AbstractControl, NG_VALIDATORS } from '@angular/forms';
import { ConversationContact } from 'app/clmtlk/shared/model/conversationContacts';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[CheckForInternalContact]',
    providers: [{
        provide: NG_VALIDATORS, useExisting: CheckForInternalContactValidator, multi: true
    }]
})

// tslint:disable-next-line:directive-class-suffix
export class CheckForInternalContactValidator implements Validator {

    @Input() fromConversationContact: ConversationContact;
    private _onChange: () => void;

    validate(c: FormGroup): ValidationErrors {

         const toControl = (<FormGroup>c.root).controls['selectedToConvContacts'];
         const ccControl = (<FormGroup>c.root).controls['selectedCcConvContacts'];
         if ( !toControl || !toControl.value || !((<Array<ConversationContact>>toControl.value).length > 0)) {
            return null;
         }

         const conversationContacts: ConversationContact[] = [this.fromConversationContact];
         toControl.value.forEach(conversationContact => {
            conversationContacts.push(conversationContact);
         });

         if (ccControl && ccControl.value && ((<Array<ConversationContact>>ccControl.value).length > 0)) {
             ccControl.value.forEach(conversationContact => {
                conversationContacts.push(conversationContact);
             });
        }

         let hasInternalContact = false;
         conversationContacts.forEach(conversationContact => {
            if (conversationContact.CTC_SRC_CD === 'st') {
                hasInternalContact = true;
            }
         });

         return hasInternalContact ? null : {CheckForInternalContact: true} ;

    };

    registerOnValidatorChange(fn: () => void): void {
        this._onChange = fn;
    }

}


// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/new-message/message-form/check-internal-contact-validator.directive.ts